import React from 'react'
import { Modal, } from 'antd';
import PostForm from './PostForm';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';
import { useNonePersistedStore } from '../../store/non-persisted-store';

export default function EditBlogPost() {
    const general = useGeneralStore();
    const { posts } = useNonePersistedStore()
    const { NotifSuccess } = general
    const visible = general.view.postEditModal;
    const post = posts.single;

    return (
        <Modal
            width="90%"
            className="custom-table"
            title="بروزرسانی پست"
            visible={visible}
            footer={false}
            onCancel={() => general.TogglePostEditModal()}>
            <PostForm
                onSubmit={() => {
                    general.TogglePostEditModal()
                    NotifSuccess('پست با موفقیت بروزرسانی شد');
                    // clearCache();
                }}
                post={post} />
        </Modal>
    )
}
